var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoResponse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2,17.3c-3.4,3.4 -6.2,6.7 -6.2,7.2 0,0.6 35.8,36.8 79.5,80.5l79.5,79.5 7.2,-7.3 7.3,-7.2 -14.1,-14.2 -14.1,-14.3 8.1,-7.7c8.8,-8.3 13.5,-15.1 17.4,-25.6 3.6,-9.4 3.8,-25.6 0.4,-35.3 -8.1,-23.4 -30.2,-41.7 -60,-49.6 -8.6,-2.3 -11.7,-2.6 -26.7,-2.7 -19,-0 -27.7,1.5 -42.2,7.5l-7.5,3.2 -10.2,-10.2c-5.6,-5.5 -10.6,-10.1 -11.1,-10.1 -0.6,-0 -3.9,2.8 -7.3,6.3zM123.4,43c22.7,5.8 40.2,20.4 45.1,37.5 4,13.6 -0.9,28 -13.5,39.9 -3.9,3.6 -7.4,6.6 -7.8,6.6 -0.4,-0 -18.9,-18.2 -41.1,-40.4l-40.3,-40.4 5.2,-1.7c14.9,-4.9 36.9,-5.6 52.4,-1.5z",
    fill: "#10CCC6",
    stroke: "#00000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3,51.2c-4.5,4.7 -9.8,13.9 -12.5,21.7 -3,8.7 -3.2,24.8 -0.4,33.1 3.7,10.9 7.8,17.2 17.8,27.3l9.8,9.9 0,18.4 0,18.4 15.8,-11.8 15.7,-11.8 5.5,1.4c3.6,0.9 11.4,1.5 22.5,1.5 14.6,0.1 18.3,-0.2 26.4,-2.2l9.4,-2.3 -8.4,-8.3 -8.4,-8.3 -6,1c-8.2,1.4 -26.4,0.3 -35.9,-2.2 -27.1,-6.9 -46.6,-26.6 -46.6,-47 0,-8.6 4.1,-18.9 9.9,-25.3l2.5,-2.8 -7,-7 -7,-6.9 -3.1,3.2z",
    fill: "#10CCC6",
    stroke: "#00000000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResponse);
export default __webpack_public_path__ + "static/media/no-response.9b08ec8e.svg";
export { ForwardRef as ReactComponent };